import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AvatarSec from "../module-common/Avatar";
import { Config } from "../constant";
import Icon from "../module-common/Icon";
import XIcon from "../assets/CloseChat.png";
import { AgentCareStore, CommonStore } from "../Store";
import Ava from "../assets/avatar.png";
import Indicator from "../module-common/Indicator";
import { observer } from "mobx-react";
import CloseToolbar from "../module-common/CloseToolbar";

export default observer(
  class Header extends Component {
    static propTypes = {
      image: PropTypes.string
    };
    
    render() {
      let companyName = Config.domain;
      const agentName = CommonStore.assignedAgent
      return (
        <HeaderSec>
          <AvatarWrapper>
            {AgentCareStore.displayPicture !== "" ? (
              <AvatarSec image={AgentCareStore.displayPicture} />
            ) : (
              <AvatarSec image={Ava} />
            )}
            <IndicatorWrapper>
              <Indicator isSmall={true} isStatus={agentName ? 'online' : 'offline'} />
            </IndicatorWrapper>
          </AvatarWrapper>
          <TitleWrapper>
            <Text>{companyName}</Text>
          </TitleWrapper>
          <CloseToolbar onClose={this.props.onClick} />
        </HeaderSec>
      );
    }
  }
);

const HeaderSec = styled.div`
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: linear-gradient(200deg, #02b8a1, #538ccf);
  height: 11%;
  @media (max-width: 360px) {
    display: flex;
    justify-content: space-between;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: linear-gradient(200deg, #02b8a1, #538ccf);
    height: 11%;
  }
  @media (max-width: 430px) {
    display: flex;
    justify-content: space-between;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: linear-gradient(200deg, #02b8a1, #538ccf);
    height: 9%;
  }
  @media (max-height: 420px) {
    display: flex;
    justify-content: space-between;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: linear-gradient(200deg, #02b8a1, #538ccf);
    height: 12%;
  }
`;
const AvatarWrapper = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  margin-left: 17px;
  width: 26px;
  height: 26px;
  @media (max-width: 360px) {
    display: flex;
    align-self: center;
    justify-content: center;
    margin-left: 17px;
    width: 26px;
    height: 26px;
  }
  @media (max-width: 430px) {
    display: flex;
    align-self: center;
    justify-content: center;
    margin-left: 17px;
    width: 28px;
    height: 28px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-self: center;
  justify-content: flex-start;
  margin-left: -120px;
`;

const Text = styled.span`
  font-size: 12px;
  align: left;
  color: white;
  font-family: "Source Sans Pro", sans-serif;
`;
const IndicatorWrapper = styled.div`
  align-self: flex-end;
  margin-left: -5px;
`;

const XIconWrapper = styled.div`
  display: flex;
  align-self: center;
  align-content: center;
  margin-right: 17px;
  width: 13px;
  height: 13px;
`;
